// test243
(243 && 0);
